import { types } from "../types/types";


const initialState={
    checking: true,
    type: 'user',
    username: '',
    scope:'',
}



export const authReducer=(state=initialState, action)=>{
    switch (action.type) {
        case types.authLogin:
            return {...state,
                ...action.payload,
            };
            
        case types.authCheckinFinish:
            return{...state,
                checking:false
            };

        case types.authCheckinInit:
            return{...state,
                checking:true
            };

        case types.authLogout:
            return {...initialState,
                checking: false
            };

        case types.authSetType:
            return {
                ...state,
                type: action.payload
            }

        case types.authSetUsername:
            return {
                ...state,
                username: action.payload
            }

        default:
            return state;
    } 
}